import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";


export const esportaSediFiltri: AnaColumn[] = [


  {
      itemType: "group", caption: "Dati Sede Legale", colCount: "2", data: [
        /*
          {
              type: 'campoSpecial',
              colVisible: false,
              dataField: "sD_RagioneSociale",
              editorType: 'dxLookup',
              width: 24.2 +'vw',
              caption: "Dalla Rag.Soc.",
              colSpan:'2',
              lista: {
                valueExpr: 'id',
                queryString: '',
                displayExpr: 'descrizione',
                dataSource: "Sede/GetAllSoggettiSedi?$filter=( isproduttore eq true )",
                static: false,
                //cascading: ['id|idMagazzinoProduttore','id|idAutorizzazioneProduttore','id|idCantiereFuoriUl'],
                colonne: [
                  {
                    dataField: 'id',
                    caption: 'Codice',
                    width:80,
                    alignment:'left'
                  },
                  {
                    dataField: 'descrizione',
                    caption: 'Descrizione'
                  },
                  {
                    dataField: 'descrizioneSoggetto',
                    caption: 'Azienda',
                    groupIndex:1
                  }
                ]
      
              },
        
              validation: [
                { type: 'required', message: 'Campo obbligatorio' }
              ]
            
          },
              
          {
            type: 'campoSpecial',
            colVisible: false,
            dataField: "aRagioneSociale",
            editorType: 'dxLookup',
            width: 24.2 +'vw',
            caption: "Alla Rag.Soc.",
            colSpan:'2',
            lista: {
              valueExpr: 'id',
              queryString: '',
              displayExpr: 'descrizione',
              dataSource: "Sede/GetAllSoggettiSedi?$filter=( isproduttore eq true )",
              static: false,
              cascading: ['id|idMagazzinoProduttore','id|idAutorizzazioneProduttore','id|idCantiereFuoriUl'],
              colonne: [
                {
                  dataField: 'id',
                  caption: 'Codice',
                  width:80,
                  alignment:'left'
                },
                {
                  dataField: 'descrizione',
                  caption: 'Descrizione'
                },
                {
                  dataField: 'descrizioneSoggetto',
                  caption: 'Azienda',
                  groupIndex:1
                }
              ]
    
            },
            
          },
          */
          {
            type: 'campoSpecial', dataField: "sD_SiglaProvincia", caption: "Provincia", width: 46 * aspect, maxLength: "45", maxSize: 45,
            colSpan:'2',/*
            validation: [{
              type: 'required', message: 'Campo obbligatorio'
            }],
            */
            dynamic: {
              costantValue: [{ key: 'stato', value: 'IT' }],
              dataSource: 'provincia',
              autocomplete: true,
              checkValue: {
                checkValueMessage: 'Provincia inesistente, vuoi continuare?',
                forceInsert: true
              },
              valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
              displayExpr: 'descrizione',
              caption: "Comuni",
              queryString: '?take=8000',
              componentType: 'grid',
              related: ['cap', 'siglaProvincia|provincia'],
    
              buttonOption: {
                text: 'Comuni',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Sfoglia Comuni',
                name: 'Comuni',
                location: 'after',
              },
    
            }
          },
    
          {
            type: 'campoSpecial', dataField: "sD_Comune", caption: "Comune", width: 46 * aspect, maxLength: "45", maxSize: 45,
            colSpan:'2',
            /*
            validation: [{
              type: 'required', message: 'Campo obbligatorio'
            }],
            */
            dynamic: {
              costantValue: [{ key: 'stato', value: 'IT' }],
              dataSource: 'comune',
              autocomplete: true,
              checkValue: {
                checkValueMessage: 'Comune inesistente, vuoi continuare?',
                forceInsert: true
              },
              valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
              displayExpr: 'descrizione',
              caption: "Comuni",
              queryString: '?take=8000',
              componentType: 'grid',
              related: ['cap', 'siglaProvincia|provincia'],
    
              buttonOption: {
                text: 'Comuni',
                icon: 'glyphicon mdi mdi-playlist-plus',
                hint: 'Sfoglia Comuni',
                name: 'Comuni',
                location: 'after',
              },
    
            }
          },
          {
              type: 'campoGriglia', colVisible: true, dataField: "sD_IdCategoria",
              dataType: "",
              width:  450 + 'px',
              height: 250 + 'px',
              colSpan:'1',
              caption: "Categorie",
              
              editorType: '',
      
              dynamic: {
                autocomplete:false,
                dataSource: 'categoria?nomeTabella=SOGGETTI',
                displayExpr: 'descrizione',
                queryString:'?nomeTabella=SOGGETTI',
                valueExpr: 'id',
                static:false,
                settingGrid:{
                  colonne:[
                    {dataField: 'descrizione', caption:'Nome Categoria',dataType:''}
                  ]
                }
                
              },
          
              
              
          },
          {
              type: 'campoGriglia', colVisible: true, dataField: "sD_IdZona",
              dataType: "",
              width: 450 + 'px',
              height:250 + 'px',
              caption: 'Zone',
              editorType: '',
              colSpan:'1',

              dynamic: {
                autocomplete:false,
                dataSource: 'zona?nomeTabella=SOGGETTI',
                displayExpr: 'descrizione',
                queryString:'?nomeTabella=SOGGETTI',
                valueExpr: 'id',
                static:false,
                settingGrid:{
                  colonne:[
                    {dataField: 'descrizione', caption:'Nome Zona',dataType:''}
                  ]
                }
              },
          },
          { type: 'empty', dataField: "", colVisible: false, dataType: "", caption: "", hideOnEdit: false, },
          { type: 'empty', dataField: "", colVisible: false, dataType: "", caption: "", hideOnEdit: false, },

      ]
    },



{
  itemType: "group", caption: "Dati Unità Locale", colCount: "3", data: [

    {
      type: 'campoSpecial', dataField: "uL_SiglaProvincia", caption: "Provincia", width: 46 * aspect, maxLength: "45", maxSize: 45,
      colSpan:'3',
      /*
      validation: [{
        type: 'required', message: 'Campo obbligatorio'
      }],
      */
      dynamic: {
        costantValue: [{ key: 'stato', value: 'IT' }],
        dataSource: 'provincia',
        autocomplete: true,
        checkValue: {
          checkValueMessage: 'Provincia inesistente, vuoi continuare?',
          forceInsert: true
        },
        valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
        displayExpr: 'descrizione',
        caption: "Comuni",
        queryString: '?take=8000',
        componentType: 'grid',
        related: ['cap', 'siglaProvincia|provincia'],

        buttonOption: {
          text: 'Comuni',
          icon: 'glyphicon mdi mdi-playlist-plus',
          hint: 'Sfoglia Comuni',
          name: 'Comuni',
          location: 'after',
        },

      }
    },

    {
      type: 'campoSpecial', dataField: "uL_Comune", caption: "Comune", width: 46 * aspect, maxLength: "45", maxSize: 45,
      colSpan:'3',
      /*
      validation: [{
        type: 'required', message: 'Campo obbligatorio'
      }],
      */
      dynamic: {
        costantValue: [{ key: 'stato', value: 'IT' }],
        dataSource: 'comune',
        autocomplete: true,
        checkValue: {
          checkValueMessage: 'Comune inesistente, vuoi continuare?',
          forceInsert: true
        },
        valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
        displayExpr: 'descrizione',
        caption: "Comuni",
        queryString: '?take=8000',
        componentType: 'grid',
        related: ['cap', 'siglaProvincia|provincia'],

        buttonOption: {
          text: 'Comuni',
          icon: 'glyphicon mdi mdi-playlist-plus',
          hint: 'Sfoglia Comuni',
          name: 'Comuni',
          location: 'after',
        },

      }
    },

    {
      type: 'campoGriglia', colVisible: true, dataField: "uL_IdCategoria",
      dataType: "",
      width:  300 + 'px',
      height: 250 + 'px',
      //colSpan:'1',
      caption: "Categorie",
      
      editorType: '',

      dynamic: {
        autocomplete:false,
        dataSource:  'categoria?nomeTabella=SEDI',
        displayExpr: 'descrizione',
        queryString:'?nomeTabella=SEDI',
        valueExpr: 'id',
        static:false,
        settingGrid:{
          colonne:[
            {dataField: 'descrizione', caption:'Nome Categoria',dataType:''}
          ]
        }
        
      },
 
    },
    
    {
      type: 'campoGriglia', colVisible: true, dataField: "uL_IdZona",
      dataType: "",
      width: 300 + 'px',
      height:250 + 'px',
      caption: 'Zona',
      editorType: '',
      //colSpan:'1',

      dynamic: {
        autocomplete:false,
        dataSource: 'zona?nomeTabella=SEDI',
        displayExpr: 'descrizione',
        queryString:'?nomeTabella=SEDI',
        valueExpr: 'id',
        static:false,
        settingGrid:{
          colonne:[
            {dataField: 'descrizione', caption:'Nome Zona',dataType:''}
          ]
        }
      },
    },

    {
      type: 'campoGriglia', colVisible: true, dataField: "uL_IdTipo",
      dataType: "",
      width: 300 + 'px',
      height:250 + 'px',   
      caption: "Tipo",
      
      editorType: '',

      dynamic: {
        autocomplete:false,
        dataSource:'tipo?nomeTabella=SEDI',
        displayExpr: 'descrizione',
        queryString: '?nomeTabella=SEDI',
        valueExpr: 'id',
        static:false,
        settingGrid:{
          colonne:[
            {dataField: 'descrizione', caption:'Nome Tipo',dataType:''}
          ]
        }
        
      },
  
      
      
    },

    /*
    {
      type: 'simpleButton', dataField: "buttonCaricaFiltroSalvato",
      colVisible: false,
      button: {
        text: 'Carica ultimo filtro salvato',
        name: "buttonCaricaFiltroSalvato",
        event: "buttonCaricaFiltroSalvato",
        type: "normal",
        hint: "Carica ultimo filtro salvato",
        //icon: "mdi mdi-google-maps",
        

        //related: ['latidudine', 'longitudine'],

      }
    },
    */
  ]
},

]

export const esportaUnitaLocaliFiltri: AnaColumn[] = [


    {
        itemType: "group", caption: "Dati Sede Legale", colCount: "2", data: [
          /*
            {
                type: 'campoSpecial',
                colVisible: false,
                dataField: "sD_RagioneSociale",
                editorType: 'dxLookup',
                width: 24.2 +'vw',
                caption: "Dalla Rag.Soc.",
                colSpan:'2',
                lista: {
                  valueExpr: 'id',
                  queryString: '',
                  displayExpr: 'descrizione',
                  dataSource: "Sede/GetAllSoggettiSedi?$filter=( isproduttore eq true )",
                  static: false,
                  //cascading: ['id|idMagazzinoProduttore','id|idAutorizzazioneProduttore','id|idCantiereFuoriUl'],
                  colonne: [
                    {
                      dataField: 'id',
                      caption: 'Codice',
                      width:80,
                      alignment:'left'
                    },
                    {
                      dataField: 'descrizione',
                      caption: 'Descrizione'
                    },
                    {
                      dataField: 'descrizioneSoggetto',
                      caption: 'Azienda',
                      groupIndex:1
                    }
                  ]
        
                },
          
                validation: [
                  { type: 'required', message: 'Campo obbligatorio' }
                ]
              
            },
                
            {
              type: 'campoSpecial',
              colVisible: false,
              dataField: "aRagioneSociale",
              editorType: 'dxLookup',
              width: 24.2 +'vw',
              caption: "Alla Rag.Soc.",
              colSpan:'2',
              lista: {
                valueExpr: 'id',
                queryString: '',
                displayExpr: 'descrizione',
                dataSource: "Sede/GetAllSoggettiSedi?$filter=( isproduttore eq true )",
                static: false,
                cascading: ['id|idMagazzinoProduttore','id|idAutorizzazioneProduttore','id|idCantiereFuoriUl'],
                colonne: [
                  {
                    dataField: 'id',
                    caption: 'Codice',
                    width:80,
                    alignment:'left'
                  },
                  {
                    dataField: 'descrizione',
                    caption: 'Descrizione'
                  },
                  {
                    dataField: 'descrizioneSoggetto',
                    caption: 'Azienda',
                    groupIndex:1
                  }
                ]
      
              },
              
            },
            */
            {
              type: 'campoSpecial', dataField: "sD_SiglaProvincia", caption: "Provincia", width: 46 * aspect, maxLength: "45", maxSize: 45,
              colSpan:'2',/*
              validation: [{
                type: 'required', message: 'Campo obbligatorio'
              }],
              */
              dynamic: {
                costantValue: [{ key: 'stato', value: 'IT' }],
                dataSource: 'provincia',
                autocomplete: true,
                checkValue: {
                  checkValueMessage: 'Provincia inesistente, vuoi continuare?',
                  forceInsert: true
                },
                valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
                displayExpr: 'descrizione',
                caption: "Comuni",
                queryString: '?take=8000',
                componentType: 'grid',
                related: ['cap', 'siglaProvincia|provincia'],
      
                buttonOption: {
                  text: 'Comuni',
                  icon: 'glyphicon mdi mdi-playlist-plus',
                  hint: 'Sfoglia Comuni',
                  name: 'Comuni',
                  location: 'after',
                },
      
              }
            },
      
            {
              type: 'campoSpecial', dataField: "sD_Comune", caption: "Comune", width: 46 * aspect, maxLength: "45", maxSize: 45,
              colSpan:'2',
              /*
              validation: [{
                type: 'required', message: 'Campo obbligatorio'
              }],
              */
              dynamic: {
                costantValue: [{ key: 'stato', value: 'IT' }],
                dataSource: 'comune',
                autocomplete: true,
                checkValue: {
                  checkValueMessage: 'Comune inesistente, vuoi continuare?',
                  forceInsert: true
                },
                valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
                displayExpr: 'descrizione',
                caption: "Comuni",
                queryString: '?take=8000',
                componentType: 'grid',
                related: ['cap', 'siglaProvincia|provincia'],
      
                buttonOption: {
                  text: 'Comuni',
                  icon: 'glyphicon mdi mdi-playlist-plus',
                  hint: 'Sfoglia Comuni',
                  name: 'Comuni',
                  location: 'after',
                },
      
              }
            },
            {
                type: 'campoGriglia', colVisible: true, dataField: "sD_IdCategoria",
                dataType: "",
                width:  450 + 'px',
                height: 250 + 'px',
                colSpan:'1',
                caption: "Categorie",
                
                editorType: '',
        
                dynamic: {
                  autocomplete:false,
                  dataSource: 'categoria?nomeTabella=SOGGETTI',
                  displayExpr: 'descrizione',
                  queryString:'?nomeTabella=SOGGETTI',
                  valueExpr: 'id',
                  static:false,
                  settingGrid:{
                    colonne:[
                      {dataField: 'descrizione', caption:'Nome Categoria',dataType:''}
                    ]
                  }
                  
                },
            
                
                
            },
            {
                type: 'campoGriglia', colVisible: true, dataField: "sD_IdZona",
                dataType: "",
                width: 450 + 'px',
                height:250 + 'px',
                caption: 'Zone',
                editorType: '',
                colSpan:'1',

                dynamic: {
                  autocomplete:false,
                  dataSource: 'zona?nomeTabella=SOGGETTI',
                  displayExpr: 'descrizione',
                  queryString:'?nomeTabella=SOGGETTI',
                  valueExpr: 'id',
                  static:false,
                  settingGrid:{
                    colonne:[
                      {dataField: 'descrizione', caption:'Nome Zona',dataType:''}
                    ]
                  }
                },
            },
            { type: 'empty', dataField: "", colVisible: false, dataType: "", caption: "", hideOnEdit: false, },
            { type: 'empty', dataField: "", colVisible: false, dataType: "", caption: "", hideOnEdit: false, },

        ]
      },



  {
    itemType: "group", caption: "Dati Unità Locale", colCount: "3", data: [

      {
        type: 'campoSpecial', dataField: "uL_SiglaProvincia", caption: "Provincia", width: 46 * aspect, maxLength: "45", maxSize: 45,
        colSpan:'3',
        /*
        validation: [{
          type: 'required', message: 'Campo obbligatorio'
        }],
        */
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          dataSource: 'provincia',
          autocomplete: true,
          checkValue: {
            checkValueMessage: 'Provincia inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          queryString: '?take=8000',
          componentType: 'grid',
          related: ['cap', 'siglaProvincia|provincia'],

          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },

        }
      },

      {
        type: 'campoSpecial', dataField: "uL_Comune", caption: "Comune", width: 46 * aspect, maxLength: "45", maxSize: 45,
        colSpan:'3',
        /*
        validation: [{
          type: 'required', message: 'Campo obbligatorio'
        }],
        */
        dynamic: {
          costantValue: [{ key: 'stato', value: 'IT' }],
          dataSource: 'comune',
          autocomplete: true,
          checkValue: {
            checkValueMessage: 'Comune inesistente, vuoi continuare?',
            forceInsert: true
          },
          valueExpr: '',//Lasciato Vuoto sen non serve l'id del DB
          displayExpr: 'descrizione',
          caption: "Comuni",
          queryString: '?take=8000',
          componentType: 'grid',
          related: ['cap', 'siglaProvincia|provincia'],

          buttonOption: {
            text: 'Comuni',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Comuni',
            name: 'Comuni',
            location: 'after',
          },

        }
      },

      {
        type: 'campoGriglia', colVisible: true, dataField: "uL_IdCategoria",
        dataType: "",
        width:  300 + 'px',
        height: 250 + 'px',
        //colSpan:'1',
        caption: "Categorie",
        
        editorType: '',

        dynamic: {
          autocomplete:false,
          dataSource:  'categoria?nomeTabella=SEDI',
          displayExpr: 'descrizione',
          queryString:'?nomeTabella=SEDI',
          valueExpr: 'id',
          static:false,
          settingGrid:{
            colonne:[
              {dataField: 'descrizione', caption:'Nome Categoria',dataType:''}
            ]
          }
          
        },
   
      },
      
      {
        type: 'campoGriglia', colVisible: true, dataField: "uL_IdZona",
        dataType: "",
        width: 300 + 'px',
        height:250 + 'px',
        caption: 'Zona',
        editorType: '',
        //colSpan:'1',

        dynamic: {
          autocomplete:false,
          dataSource: 'zona?nomeTabella=SEDI',
          displayExpr: 'descrizione',
          queryString:'?nomeTabella=SEDI',
          valueExpr: 'id',
          static:false,
          settingGrid:{
            colonne:[
              {dataField: 'descrizione', caption:'Nome Zona',dataType:''}
            ]
          }
        },
      },

      {
        type: 'campoGriglia', colVisible: true, dataField: "uL_IdTipo",
        dataType: "",
        width: 300 + 'px',
        height:250 + 'px',   
        caption: "Tipo",
        
        editorType: '',

        dynamic: {
          autocomplete:false,
          dataSource:'tipo?nomeTabella=SEDI',
          displayExpr: 'descrizione',
          queryString: '?nomeTabella=SEDI',
          valueExpr: 'id',
          static:false,
          settingGrid:{
            colonne:[
              {dataField: 'descrizione', caption:'Nome Tipo',dataType:''}
            ]
          }
          
        },
    
        
        
      },

      /*
      {
        type: 'simpleButton', dataField: "buttonCaricaFiltroSalvato",
        colVisible: false,
        button: {
          text: 'Carica ultimo filtro salvato',
          name: "buttonCaricaFiltroSalvato",
          event: "buttonCaricaFiltroSalvato",
          type: "normal",
          hint: "Carica ultimo filtro salvato",
          //icon: "mdi mdi-google-maps",
          

          //related: ['latidudine', 'longitudine'],

        }
      },
      */
    ]
  },
 
]